module.exports = __webpack_public_path__ + "img/default.f86a1ddd.png";